import { Currency } from "@redotech/money/currencies";
import * as z from "zod";

/** Attributed order revenue + order count for one marketing entity + currency. */
export const attributedMetricSchema = z.object({
  revenue: z.number(),
  orders: z.number(),
});
export type AttributedMetric = z.infer<typeof attributedMetricSchema>;

/** Kept per currency because currencies are never combined or converted. */
export const perCurrencyMetricsSchema = z.partialRecord(
  z.enum(Currency),
  attributedMetricSchema,
);
export type PerCurrencyMetrics = z.infer<typeof perCurrencyMetricsSchema>;

/** Attributed order metrics keyed by the grouped scope's id (campaign id, etc.). */
export const attributionSchema = z.record(z.string(), perCurrencyMetricsSchema);
export type Attribution = z.infer<typeof attributionSchema>;
